'use es6'; // TODO move to ecosystem-marketplace-core

import Immutable from 'immutable';
import { cleanObject } from 'ecosystem-marketplace-core/utils/formatters';
const defaults = {
  certifiedAt: null,
  connectionType: null,
  firstPublishedAt: 0,
  homemade: false,
  installsCount: 0,
  slug: '',
  sourceId: '',
  typeId: 1
};

class ThinOffering extends Immutable.Record(defaults) {
  constructor(json = {}) {
    super(cleanObject(json));
  }

}

export default ThinOffering;